import { AppDialog } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { AlertCircle } from 'lucide-react'

interface UnsavedChangesConfirmDialogProps {
  /** ダイアログの開閉状態 */
  open: boolean
  /** ダイアログの開閉状態を変更するコールバック */
  onOpenChange: (open: boolean) => void
  /** 変更を破棄して移動する際のコールバック */
  onDiscard: () => void
  /** ダイアログタイトル */
  title: string
  /** 確認メッセージ */
  message: string
}

/**
 * UnsavedChangesConfirmDialog - 破棄確認ダイアログの表示コンポーネント
 *
 * タイトル・メッセージは呼び出し側が文脈に応じて指定する。
 */
export function UnsavedChangesConfirmDialog({
  open,
  onOpenChange,
  onDiscard,
  title,
  message,
}: UnsavedChangesConfirmDialogProps) {
  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      title={
        <span className='flex items-center gap-2 text-amber-600 dark:text-amber-400'>
          <AlertCircle className='size-5' />
          {title}
        </span>
      }
      className='sm:max-w-md'
      footerOptions={[
        { label: '戻る', onClick: () => onOpenChange(false), variant: 'ghost' },
        { label: '破棄する', onClick: onDiscard, variant: 'destructive' },
      ]}
    >
      <div className='space-y-4 py-4'>
        <div className='space-y-2'>
          <p className='text-sm'>{message}</p>
        </div>
      </div>
    </AppDialog>
  )
}
